import { createFont, createTamagui, createTokens, isWeb } from 'tamagui';

import { adultingMedia } from './media';
import { adultingDefaultTheme, adultingThemes } from './themes';
import {
  adultingBodyWeightTokens,
  adultingColorTokens,
  adultingHeadingWeightTokens,
  adultingLetterSpacingTokens,
  adultingLineHeightTokens,
  adultingRadiusTokens,
  adultingSizeTokens,
  adultingSpaceTokens,
  adultingZIndexTokens,
} from './tokens';

const systemFontFamily = isWeb
  ? '-apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
  : 'System';

const bodyFont = createFont({
  family: systemFontFamily,
  size: adultingSizeTokens,
  lineHeight: adultingLineHeightTokens,
  weight: adultingBodyWeightTokens,
  letterSpacing: adultingLetterSpacingTokens,
});

const headingFont = createFont({
  family: systemFontFamily,
  size: adultingSizeTokens,
  lineHeight: adultingLineHeightTokens,
  weight: adultingHeadingWeightTokens,
  letterSpacing: adultingLetterSpacingTokens,
});

export const adultingTokens = createTokens({
  color: adultingColorTokens,
  space: adultingSpaceTokens,
  size: adultingSizeTokens,
  radius: adultingRadiusTokens,
  zIndex: adultingZIndexTokens,
});

export const adultingTamaguiConfig = createTamagui({
  tokens: adultingTokens,
  themes: adultingThemes,
  media: adultingMedia,
  fonts: {
    body: bodyFont,
    heading: headingFont,
  },
  shorthands: {
    ai: 'alignItems',
    bg: 'backgroundColor',
    bw: 'borderWidth',
    br: 'borderRadius',
    fd: 'flexDirection',
    gap: 'gap',
    jc: 'justifyContent',
    m: 'margin',
    mb: 'marginBottom',
    ml: 'marginLeft',
    mr: 'marginRight',
    mt: 'marginTop',
    mx: 'marginHorizontal',
    my: 'marginVertical',
    p: 'padding',
    pb: 'paddingBottom',
    pl: 'paddingLeft',
    pr: 'paddingRight',
    pt: 'paddingTop',
    px: 'paddingHorizontal',
    py: 'paddingVertical',
  },
  settings: {
    defaultFont: 'body',
    themeClassNameOnRoot: true,
  },
  defaultTheme: adultingDefaultTheme,
});

export type AdultingTamaguiConfig = typeof adultingTamaguiConfig;

declare module 'tamagui' {
  interface TamaguiCustomConfig extends AdultingTamaguiConfig {}
}

export default adultingTamaguiConfig;
